/**
 * Session-only dismissal of the mating-predictor inbreeding explainer alert.
 * Backed by `sessionStorage` and synced across instances via a window event, so
 * it can drive a `useSyncExternalStore` subscription.
 */

/** Session-only: hide inbreeding explainer after dismiss until tab is closed. */
const SESSION_INBREEDING_INFO_DISMISSED_KEY =
  'breedlogic.matingPredictor.inbreedingInfoAlertDismissed';

const INBREEDING_INFO_DISMISSED_EVENT =
  'breedlogic-mating-inbreeding-dismissed';

export function subscribeInbreedingInfoDismissed(onStoreChange: () => void) {
  if (typeof window === 'undefined') return () => {};
  const handler = () => onStoreChange();
  window.addEventListener(INBREEDING_INFO_DISMISSED_EVENT, handler);
  return () =>
    window.removeEventListener(INBREEDING_INFO_DISMISSED_EVENT, handler);
}

export function getInbreedingInfoDismissedSnapshot(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return (
      sessionStorage.getItem(SESSION_INBREEDING_INFO_DISMISSED_KEY) === '1'
    );
  } catch {
    return false;
  }
}

/** Persist the dismissal and notify subscribers in this tab. */
export function markInbreedingInfoDismissed(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(SESSION_INBREEDING_INFO_DISMISSED_KEY, '1');
  } catch {
    // ignore
  }
  window.dispatchEvent(new Event(INBREEDING_INFO_DISMISSED_EVENT));
}
